import { render, staticRenderFns } from "./BasePrintButton.vue?vue&type=template&id=5ded105e"
import script from "./BasePrintButton.vue?vue&type=script&lang=js"
export * from "./BasePrintButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports